// extracted by mini-css-extract-plugin
module.exports = {"component":"location-module--component--1jiqK","label":"location-module--label--2hyLp","loading":"location-module--loading--30ELY"};